'use strict';

var React = require('react');
var classnames = require('classnames');
var styleInject_es = require('./style-inject.es-9d2f5f4e.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classnames__default = /*#__PURE__*/_interopDefaultLegacy(classnames);

var css_248z$1 = ".SRYe3DkjH1c- > :not(:last-child) {\n  margin-bottom: calc(16px * 1);\n  margin-bottom: var(--space-base);\n}\n\n.rDJFaGPzCbE- > :not(:last-child) {\n  margin-bottom: calc(16px / 2);\n  margin-bottom: var(--space-small);\n}\n\n._7TZ4MI3kr4Y- > :not(:last-child) {\n  margin-bottom: calc(16px * 1.5);\n  margin-bottom: var(--space-large);\n}\n";
var spacings = {"base":"SRYe3DkjH1c-","small":"rDJFaGPzCbE-","large":"_7TZ4MI3kr4Y-"};
styleInject_es.styleInject(css_248z$1);

var css_248z = "._4On2F-4nWuY- {\n  padding: 0;\n  padding: var(--public-content--padding, 0);\n}\n";
var styles = {"padded":"_4On2F-4nWuY-"};
styleInject_es.styleInject(css_248z);

function Content({ children, spacing = "base" }) {
    const className = classnames__default["default"](styles.padded, spacings[spacing]);
    return React__default["default"].createElement("div", { className: className }, children);
}

exports.Content = Content;
